import type { RpaExecutorStateSnapshot, RpaExecutorStopCause } from '@/tauri/rpa';

// `task_failed` is excluded — a natural failure resolves via the harness
// timeline's own terminal state, not an optimistic "Stopping…".
export const isCancelStopCause = (cause: RpaExecutorStopCause | undefined): boolean =>
  cause === 'user' || cause === 'lease_lost';

// `stopCause` is recorded when teardown is signalled, before `status` is
// `stopped`, so this also covers the drain window.
export const isExecutorStopSignalled = (
  snapshot: RpaExecutorStateSnapshot | null | undefined,
  childRunId: string | undefined
): boolean =>
  !!childRunId &&
  snapshot?.agentRunId === childRunId &&
  isCancelStopCause(snapshot.stopCause);
